import { render, staticRenderFns } from "./OrderRecordsTab.vue?vue&type=template&id=dbc3c74c"
import script from "./OrderRecordsTab.vue?vue&type=script&lang=js"
export * from "./OrderRecordsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports